import { render, staticRenderFns } from "./summary-value.vue?vue&type=template&id=62b778cf&"
import script from "./summary-value.vue?vue&type=script&lang=js&"
export * from "./summary-value.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports